import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";

const FORM_TYPES = [
  { value: 0, label: "Preventive Maintenance" },
  { value: 1, label: "Equipment Startup" },
  { value: 2, label: "Equipment Calibration" },
  { value: 3, label: "Line Break" },
  { value: 4, label: "Hot Work" },
];

const FormTypeDropdown = ({ selectedValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel =
    selectedValue !== null && selectedValue !== undefined
      ? FORM_TYPES.find((t) => t.value === selectedValue)?.label || "Select"
      : "Select";

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          <span className="font-OpenSansRegular text-[12px]">{selectedLabel}</span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            {FORM_TYPES.map((type) => (
              <li
                key={type.value}
                onClick={() => {
                  onSelect(type.value);
                  setIsOpen(false);
                }}
                className="px-4 py-1 cursor-pointer hover:bg-gray-200"
              >
                <span className="font-OpenSansRegular text-[12px]">{type.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export { FORM_TYPES };
export default FormTypeDropdown;
